




















import LocalData from '@/mixins/local-data';
import {Component, Mixins, Prop} from 'vue-property-decorator';
import ModuleTabsManagement from "@/pages/ModuleItems/ModuleTabs/ModuleTabsManagement.vue";
import {Promotions, Sales, SelectMarket} from "@/interfaces/global-data";
import MarketSelect from '@/components/MarketSelect.vue';
import { TModuleType } from "@/pages/ModuleItems/data";

@Component({
    components: {
        MarketSelect,
        ModuleTabsManagement,
    },
})

export default class ModuleManagement extends Mixins(LocalData) {
    @Prop({ default: null }) readonly activeTabKeyProp?: string | null;
    @Prop() readonly moduleType!: TModuleType;

    get moduleData(): Sales | Promotions {
        if (this.moduleType === 'promo') {
            return this.$promotions;
        } else {
            return this.$sales;
        }
    }

    set moduleData(data: Sales | Promotions) {
        if (this.moduleType === 'promo') {
            this.$promotions = data as Promotions;
        } else {
            this.$sales = data as Sales;
        }
    }

    private isRenderModuleTabs: boolean = true;

    updateSelectMarket(market: SelectMarket) {
        if (this.moduleData.selectMarket.id !== market.id) {
            this.moduleData.selectMarket = market;

            this.moduleData.individualConfig = {};

            localStorage.setItem(this.moduleType === 'promo' ? 'promotions' : 'sales', JSON.stringify(this.moduleData));

            this.isRenderModuleTabs = false;

            this.$nextTick(() => {
                this.isRenderModuleTabs = true;
            });
        }
    }
}
